export const MEDICAL_TEMPLATE = "MEDICAL_TEMPLATE"
export const DONOR_CHECKRECORDS = "DONOR_CHECKRECORDS"
export const KPI_DATA = "KPI_DATA"
export const INDENTIFY_DONOR_DATA = "INDENTIFY_DONOR_DATA"
export const RECENT_DONOR_INF_DATA = "RECENT_DONOR_INF_DATA"
export const RECENT_DONOR_SCREENING_DATA = "RECENT_DONOR_SCREENING_DATA"
export const RECENT_DONOR_SCREENING_DATA_LIST = "RECENT_DONOR_SCREENING_DATA_LIST"
export const RECENT_DONOR_SCREENING_DATA_SCREEN = "RECENT_DONOR_SCREENING_DATA_SCREEN"
export const RECENT_DONOR_SCREENING_DATA_SCREEN_TEST = "RECENT_DONOR_SCREENING_DATA_SCREEN_TEST"
export const RECENT_DONOR_COLLECTION_DATA = "RECENT_DONOR_SCREENING_DATA_SCREEN_TEST"
export const RECENT_DONOR_COLLECTION_COUNT = "RECENT_DONOR_COLLECTION_COUNT"
export const RECENT_DONOR_COLLECTION_COUNT_LOAD = "RECENT_DONOR_COLLECTION_COUNT_LOAD"
export const RECENT_DONOR_COLLECTION_LOAD = "RECENT_DONOR_COLLECTION_LOAD"